// extracted by mini-css-extract-plugin
export default {"icon-link":"icon-link---OgLez"};